import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

import { SagawaEhidenService } from '../../../service/sagawa-ehiden/sagawa-ehiden.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { isSingleOwner } from 'app/menu/header/header.component';

@Component({
  selector: 'app-root',
  templateUrl: 'wa3921.component.html',
  styleUrls: ['wa3921.component.scss']
})
export class Wa3921Component implements AfterViewInit {
  public componentTitle = 'WA3921:e飛伝　出荷データ出力';

  public owners: any;
  public ownerId: number;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  private tabsNr: number = 1;
  private ownerResult;
  private isShowSendLoading = false;
  private isOwnerFixed = false;

  constructor(
    private router: Router,
    private sagawaEhidenService: SagawaEhidenService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) { 
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
    sessionStorage.removeItem('isShowOwnerSelect');
    if (isSingleOwner) {
      this.isOwnerFixed = true;
    } else this.isOwnerFixed = false;
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {
        this.ownerResult = sessionStorage.getItem('ownerResult');
        if (this.ownerResult !== null) {
          const selectedOwner = JSON.parse(this.ownerResult);
          this.ownerId = selectedOwner.ownerId;
        }
        this.owners = outputJson.owners;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;

    if (this.ownerId === undefined) {
      this.errorInfo = '荷主を選択してください';
      this.isShowSendLoading = false;
      return;
    }

    this.sagawaEhidenService
      .get(this.ownerId)
      .then(res => {
        if (res) {
          this.downloadFile(res.text());
        }
        setTimeout(() => {
          this.isShowSendLoading = false;
          this.working = false;
        },300);
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
        this.working = false;
      });
  }

  downloadFile(unicodeSting) {
    // UNICODEからSJISへ変換する
    const sjisSting = this.commonService.toSJis(unicodeSting);
    // 指定されたデータを保持するBlobを作成する
    const blob = new Blob(sjisSting, { type: 'text/csv' });
    // Internet Explorer
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, 'ehiden.csv');
    } else {
      // Chrome
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = 'ehiden.csv';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }

  tabs(type) {
    this.tabsNr = type;
    this.errorInfo = '';
  }

  inputErr(e) {
    this.errorInfo = e;
  }
  clickOwnerBox() {
    this.errorInfo = '';
  }

  ngDoCheck() {
    if (isSingleOwner) {
      this.isOwnerFixed = true;
    } else this.isOwnerFixed = false;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3921/wa3921.component.ts